<template>
  <!-- table组件 -->
  <div class="table-view">
    <el-table class="hb-table-view" height="100%" :data="tableData" stripe :ref="thisRef" :cell-style="cellStyle" :header-cell-style="headerCellStyle" :row-style="rowStyle" @selection-change="handleSelectionChange" @cell-click="cellClick">
      <template v-for="(item, index) in columns">
        <el-table-column :type="item.type" :width="55" align="left" v-if="item.type == 'selection'" :key="index"></el-table-column>
        <el-table-column :prop="item.prop" :label="item.label" :width="item.width ? item.width : ''" :align="item.align ? item.align : 'center'" v-if="!item.type&&!item.formatter" :key="index" show-overflow-tooltip></el-table-column>
        <el-table-column :prop="item.prop" :label="item.label" :width="item.width ? item.width : ''" :align="item.align ? item.align : 'center'" v-if="!item.type&&item.formatter" :key="index" show-overflow-tooltip :formatter='formatter'></el-table-column>
        <el-table-column :type="item.type" :prop="item.prop" :label="item.label" :width="item.width ? item.width : ''" :align="item.align ? item.align : 'center'" v-if="item.type == 'image'" :key="index" show-overflow-tooltip>
          <template slot-scope="scope" v-if="scope.row.imageRecordPath">
            <el-image class="hb-table-view-image" @click="handleClickImageMask" :src="scope.row.imageRecordPath" :preview-src-list="[scope.row.imageRecordPath]"></el-image>
          </template>
        </el-table-column>
        <el-table-column :label="item.label ? item.label : '操作'" :width="item.width ? item.width : ''" align="center" v-if="item.type == 'slot'" :key="index" :fixed="item.fixed?item.fixed:false">
          <template slot="header" slot-scope="scope">
            <span>{{ item.label ? item.label : '操作' }}</span>
            <template v-for="(optItem, index) in optConfig">
              <el-button type="primary" size="mini" icon="el-icon-plus" style="margin-left: 10px;float: right;" circle v-if="optItem == 'add'" @click="handleOpt('add')" :key="index + 'add'"></el-button>
              <el-button type="primary" size="mini" icon="el-icon-download" style="margin-left: 10px;float: right;" circle v-if="optItem == 'out'" @click="handleOpt('out')" :key="index + 'download'"></el-button>
              <el-button type="primary" size="mini" icon="el-icon-upload2" style="margin-left: 10px;float: right;" circle v-if="optItem == 'in'" @click="handleOpt('in')" :key="index + 'upload'"></el-button>
            </template>
          </template>
          <template slot-scope="scope">
            <template v-for="(item2, index2) in item.slot">
              <el-button type="text" size="mini" :icon="item2.icon ? item2.icon : 'el-icon-edit'" :style="item2.color ? 'color:' + item2.color : 'color:#17A48B'" @click="handleSolt(index2, scope.row)" v-if="!item2.api" :key="index2">
                {{ item2.label }}
              </el-button>
              <el-button type="text" size="mini" icon="el-icon-delete" style="color:#888FA0" @click="handleDel(item2.api, scope.row, item2.idkey)" v-if="item2.api" :key="index2">
                删除
              </el-button>
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <div class="pagination">
      <el-pagination background @current-change="currentChange" @size-change="sizeChange" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" :total="total"></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      thisRef: this._uid + '_tableRef',
      columns: [], //表头参数
      tableData: [], //table数据
      total: 0, //table数据总数
      pageIndex: 1, //当前页
      pageSize: 10, //每页显示数据量
      headerCellStyle: {
        color: '#0A0F1B',
        textAlign: 'center',
      }, //table表头样式
      cellStyle: { padding: '10px 0' }, //table单元格样式
      rowStyle: {
        color: '#959CAE',
      },
      searchData: {}, //筛选数据
      doGet: false, //是否正在获取table
      multipleSelection: [],
    }
  },
  props: {
    config: {
      Type: Object,
    },
    multipleSelectionChange: {
      Type: Object,
    },
    handleSolt: {
      Type: Object,
    },
    handleCellClick: {
      Type: Object,
    },
    optConfig: {
      Type: Object,
    },
    handleOpt: {
      Type: Object,
    },
    isBatchDelete: {
      Type: Boolean | String,
      default: false,
    },
    formatter: {
      type: Function,
      default: function () {},
    },
    isAutoGet: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.init()
    if (this.isAutoGet) {
      this.getData(1, 10, true)
    }
  },
  methods: {
    //初始化
    init() {
      let that = this
      // console.log(this.thisRef, '初始化tableConfig', this.config)
      if (this.config) {
        this.columns = this.config.columns
        if (this.columns.headerCellStyle) {
          this.headerCellStyle = this.columns.headerCellStyle
        }
        if (this.columns.cellStyle) {
          this.cellStyle = this.columns.cellStyle
        }
        this.columns.forEach(function (item, index) {
          if (item.slot) {
            that.cellStyle = { padding: '10px 0' }
          }
        })
        if (this.config.data) {
          this.tableData = this.config.data
        }
      } else {
        that.$message({
          message: 'table组件初始化失败',
          duration: 2000,
          type: 'error',
        })
      }
    },
    //获取table数据
    getData(pageIndex, pageSize, refreshTotalRowsNumber, defCondition) {
      let that = this
      if (!this.config.api) {
        return
      }
      if (this.doGet) {
        return
      }
      this.doGet = true
      setTimeout(function () {
        if (that.doGet) {
          that.doGet = false
        }
      }, 2000)
      let data = {}
      data = Object.assign(this.searchData, defCondition)

      data.size = pageSize
      data.current = pageIndex
      this.$API[this.config.api](data).then((res) => {
        that.doGet = false
        that.total = parseInt(res.total)
        that.tableData = res.records
        this.$nextTick(() => {
          this.$refs[this.thisRef].doLayout()

          // el-table加ref="multipleTable"
        })
        this.multipleSelectionInit(res.pages)
      })
    },
    multipleSelectionInit(pages) {
      if (this.multipleSelection) {
        this.multipleSelection = []
        for (let i = 0; i < pages; i++) {
          this.multipleSelection.push([])
        }
      }
    },
    //刷新table
    tableUpdate() {
      this.getData(this.pageIndex, this.pageSize, true)
    },
    // 分页导航
    currentChange(val) {
      this.pageIndex = val
      this.tableUpdate()
    },
    //改变单页显示数量
    sizeChange(val) {
      this.pageSize = val
      this.tableUpdate()
    },
    //多选触发改变
    handleSelectionChange(val) {
      this.multipleSelectionChange(val, this.pageIndex)
    },
    //触发筛选
    doSearch(data) {
      this.searchData = data
      this.pageIndex = 1
      this.pageSize = 10
      this.tableUpdate()
    },
    //row触发删除
    handleDel(_api, row, idkey) {
      this.$confirm('删除后无法恢复,确定删除吗？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        // center:true
      })
        .then(() => {
          let that = this
          let data = {}
          if (this.isBatchDelete === true || this.isBatchDelete === 'true' || this.isBatchDelete === '') {
            data.idList = []
            if (idkey == undefined) {
              data.idList.push(row.id)
            } else {
              data.idList.push(row[idkey])
            }
          } else {
            if (idkey == undefined) {
              data.id = row.id
            } else {
              data.id = row[idkey]
            }
          }
          this.$API[_api](data).then(
            (res) => {
              this.$message({
                message: '删除成功',
                duration: 2000,
                type: 'success',
              })
              this.tableUpdate()
            },
            (err) => {}
          )
        })
        .catch(() => {
          // console.log('点击了取消');
        })
    },
    //单元格点击
    cellClick(row, column, cell, event) {
      if (this.handleCellClick) {
        this.handleCellClick(row, column)
      }
    },
    handleClickImageMask() {
      this.$nextTick(() => {
        // 待页面加载完毕，获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
  },
}
</script>

<style>
.table-view {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.hb-table-view {
  flex: 1;
}
/* .pagination {
    padding: 20px ;
    text-align: right;
  } */
.el-pager li {
  border-radius: 10px !important;
}
.hb-table-view-image {
  height: 50px;
  width: 50px;
  cursor: pointer;
}
/* >>>.el-table{
	overflow-x:auto!important
} */
</style>



// WEBPACK FOOTER //
// src/components/parts/hbTable.vue